function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  fill: "#004152",
  fillRule: "evenodd",
  d: "M6.005 1.317c0-.273.045-.5.332-.5.28 0 .443.227.443.5l.344 3.5c0 .714-.314 1.347-.807 1.8l.02-.006c-.028.028-.057.052-.09.079-.005.004-.01.01-.017.014l-.01.007c-.014.009-.024.015-.03.026-.266.22-.213 1.04-.213 1.04v8.04c0 .514-.407.934-.927.987l-.106.013-.107-.013c-.52-.047-.927-.467-.927-.987V7.791l.002-.214c.005-.416.008-.65-.222-.846l-.02-.02-.041-.034c-.028-.022-.056-.044-.079-.066l.02.006c-.493-.453-.806-1.086-.806-1.8l.29-3.5c0-.273.145-.5.425-.5.287 0 .386.227.386.5l-.068 3.387c0 .427.153.807.413 1.093 0 0 .22.22.22-.2l.102-4.28c0-.273.132-.5.412-.5.286 0 .431.227.425.5l.088 4.28c.007.42.227.187.227.187.253-.287.406-.667.406-1.087l-.085-3.38zm6.41-.5c-.134 0-.26.052-.348.153-.589.675-2.85 3.58-2.948 8.512-.004.184.145.335.33.335h1.393c.185 0 .334.15.334.334v5.666c0 .552.461 1 1.03 1s1.03-.448 1.03-1v-14.5c0-.276-.23-.5-.515-.5h-.307z",
  clipRule: "evenodd"
});

var SvgForkAndKnife = function SvgForkAndKnife(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    viewBox: "0 0 16 17",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgForkAndKnife, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fork-and-knife.d29f8b0a.svg";
export { ForwardRef as ReactComponent };